import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import joi, { ObjectSchema } from 'joi';
import { JoiValidationOptionsConstant } from '@vivli/shared/infrastructure/constants';
import { IDisclosure } from '@vivli/features/disclosures/infrastructure/interface';
import { DisclosureTypeEnum } from '@vivli/features/disclosures/infrastructure/enum';

const formSchema: ObjectSchema<IDisclosure> = joi
    .object({
        title: joi.string().required().label('Title'),
        journalOrConferenceName: joi.string().required().label('Journal/Conference/Other'),
        disclosureType: joi.number().min(1).required(), // don't allow a 0, which means none selected
        otherDisclosureType: joi
            .optional()
            .when('disclosureType', {
                is: DisclosureTypeEnum.Other,
                then: joi.string().required(),
                otherwise: joi.optional(),
            })
            .label('Other Disclosure Type'),
        studyDisclosureDetails: joi.array().min(1).required(),
    })
    .options(JoiValidationOptionsConstant);

export function useDisclosureFormHook(disclosure?: IDisclosure, mode: 'onBlur' | 'onChange' | 'onTouched' | 'all' = 'all') {
    return useForm({
        mode,
        resolver: joiResolver(formSchema),
        defaultValues: disclosure,
        reValidateMode: 'onChange',
    });
}
